export default [
  {
    id: "401kai",
    name: "",
    img: require("@/assets/products/remai.jpg"),
    description: "401kAI & AdvisorAI 2.0 allow you to communicate frequently without spending much time.",
    video: 'https://player.vimeo.com/video/826963909?title=0&byline=0&portrait=0',
    landing: '401kai_adviser',
    productCode: '401kai',
    icon:  "401kai_adviser.png",
    icon2:  "401kai_adviser.png",
    link: "/401kai",
    defaultLink: "/401kai",
    drawerName: "401kAi",
    site: "401kai",
    rd: '',
    favicon: 'favicon-lexe.ico',
    rdid: '401kai',
    hideStart: true,
    hideTrial: true,
    extraClass: "only-icon",
    main: true
  },
  {
    id: "lexe",
    name: "Larkspur Executive PRO & Platinum",
    img: require("@/assets/products/LEXE-MIN.png"),
    description: "Stay calm & sell retirement plans from home: retirement plan database with data and analytics on 850k+ plans, daily update plus 1.2M+ executives with contact info.",
    video: 'https://player.vimeo.com/video/398820353?dnt=1&app_id=122963',
    landing: 'landings_proplus',
    productCode: 'LEXE',
    icon:  "LEXE.png",
    icon2:  "LEXE.png",
    link: "/larkspurexecutive/index",
    defaultLink: "/larkspurexecutive/index",
    drawerName: "Lakrspur Executive",
    site: "larkspurexecutive",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=LEXE',
    favicon: 'favicon-lexe.ico',
    rdid: 'lexe',
  },
  {
    id: "remai",
    name: "",
    img: require("@/assets/products/401kai.jpg"),
    description: `RemAI is the newest software that answers complicated investment questions with detailed answers, supported by data and charts. The result can be used immediately to:
    invest;
    publish and win clients;
    communicate with existing clients as a trusted advisor`,
    video: 'https://player.vimeo.com/video/884439766?dnt=1&app_id=122963',
    landing: 'landings_remai',
    productCode: 'REMAI',
    icon:  "REMAI.png",
    icon2:  "REMAI.svg",
    link: "/remai/index",
    defaultLink: "/remai/index",
    drawerName: "RemAI",
    site: "remai",
    // single: true,
    // onlyLanding: true,
    rd: '',
    favicon: 'favicon-remai.png',
    rdid: 'remai',
    mvp: true,
    // hideStart: true,
    hideTrial: true,
    extraClass: "only-icon",
  },
  {
    id: "rbo",
    name: "RegBi Optimizer",
    img: require("@/assets/products/RBO.png"),
    description: "When the SEC knocks, how will you prove compliance? Regulation Best Interest requires documentation when performing rollovers. SEC is starting to examine advisors after a grace period.",
    video: 'https://player.vimeo.com/video/387387913?dnt=1&app_id=122963',
    landing: 'landings_regbioptimizer',
    productCode: 'REGBI',
    link: "/regbioptimizer/homescreen",
    defaultLink: "/regbioptimizer/homescreen",
    icon:  "RBO.png",
    icon2:  "RBO.png",
    drawerName: "RegBi Optimizer",
    site: "regbioptimizer",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=RegBi',
    rdid: 'regbi'    
  },
  {
    id: "401k",
    name: "401kFiduciaryOptimizer",
    img: require("@/assets/products/401k.jpeg"),
    description: "Plan prospecting software + the largest database of qualified plan data combined with intelligence on 1.2+ million plan executives, their social network profiles and corporate contact data.",
    video: 'https://player.vimeo.com/video/515166248?dnt=1&app_id=122963',
    landing: "landings_401k",
    productCode: 'FCT',
    icon:  "FCT.png",
    icon2:  "FCT.png",
    link: "/401k/similarity",
    defaultLink: "/401k/similarity",
    drawerName: "401k",
    site: "401k",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=401k',
    rdid: '401k'
  },
  {
    id: "pctpro",
    name: "Portfolio Crash Testing PRO",
    img: require("@/assets/products/PCT.jpeg"),
    description: "Become a trusted risk management advisor by applying science-based risk software. PCT is a premier portfolio analytics and financial planning tool created by Wall Street quants with decade of experience. Separate yourself from the pack with top notch analytics.",
    video: 'https://player.vimeo.com/video/340714768?dnt=1&app_id=122963',
    landing: 'pct',
    productCode: 'OLD_PCT',
    icon:  "pctpro.png",
    icon2:  "pctpro.png",
    link: "/pctpro",
    defaultLink: "/pctpro",
    drawerName: "PCT PRO",
    site: "pctpro",
    single: true,
    // onlyLanding: true,
    rd: '/requestdemo?product=PCT&hide-topmenu=true&appstore=true',
    rdid: 'pct'
  },
  {
    id: "pow",
    name: "Prospects of Wealth 2.0",
    img: require("@/assets/products/POW.png"),
    description: "Swing for the home run more often with 4+ million corporate Executives and HNWI featuring detailed contact data, social network profiles, retirement plan holding data & more.",
    landing: "landings_pow",
    video: 'https://player.vimeo.com/video/273328255?dnt=1&app_id=122963',
    productCode: 'POW2',
    link: "/pow/search",
    defaultLink: "/pow/search",
    icon:  "POW.png",
    icon2:  "POW.png",
    drawerName: "POW",
    site: "pow",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=POW',
    rdid: 'pow',
    hideTrial: true
  },
  // {
  //   id: "IRA",
  //   name: "IRAFiduciaryOptimizer",
  //   img: require("@/assets/products/IRA.png"),
  //   description: "IRAFiduciaryOptimizer uses portfolio analytics and 401(k) plan data from virtually every plan in the country to make it easy to document rollovers.",
  //   landing: "IRA",
  //   video: 'https://player.vimeo.com/video/205262271?dnt=1&app_id=122963',
  //   productCode: 'IRA',
  //   link: "/irafiduciaryoptimizer/index",
  //   icon:  "IRAFO.png",
  //   drawerName: "IRA FO"
  
  // },

  
  {
    id: "crm",
    name: "CRM",
    img: require("@/assets/products/CRM.png"),
    description: "Modern CRM with built-in email campaigns: according to research, a prospect needs to interact with your content 6-7 times before deciding to pursue a relationship. Campaigns give you that!",
    landing: "landings_crm",
    video: 'https://player.vimeo.com/video/468570711?title=0&byline=0&portrait=0',
    productCode: 'CRM',
    link: "/crm/tasks",
    defaultLink: "/crm/tasks",
    icon:  "CRM.png",
    icon2:  "CRM.png",
    drawerName: "CRM",
    site: "crm",
    mvp: true,
    rd: '/requestdemo?rdemoiframe=true&source=proplus&product=CRM&hide-topmenu=true&appstore=true',
    rdid: 'crm'
  },

  {
    id: "co",
    name: "CoinOptimizer",
    img: require("@/assets/products/CO.png"),
    description: "Coinoptimizer was built by an award winning investment research team to help you understand and explain behavior of cryptocurrencies.",
    landing: "landings_coinoptimizer",
    video: 'https://player.vimeo.com/video/261184805?title=0&byline=0&portrait=0',
    productCode: 'CO',
    link: "/coinoptimizer/index",
    defaultLink: "/coinoptimizer/index",
    icon:  "CO.png",
    icon2:  "CO.png",
    drawerName: "CoinOptimizer",
    site: "coinoptimizer",
    mvp: false,
    rd: '/requestdemo?product=CO&hide-topmenu=true&appstore=true',
    rdid: 'co'
  },
  
  {
    id: "ps",
    name: "Planisphere",
    img: require("@/assets/products/PS.png"),
    description: "Planisphere contains detailed information on nearly one million qualified retirement and group benefit plans.",
    landing: 'landings_planisphere',  
    video: 'https://player.vimeo.com/video/398820353?title=0&byline=0',
    productCode: 'PS',
    link: "/planisphere/index",
    defaultLink: "/planisphere/index",
    icon:  "PS.png",
    icon2:  "PS.png",
    drawerName: "Planisphere",
    site: "planisphere",
    rd: "/requestdemo?product=LPS&hide-topmenu=true&appstore=true",
    rdid: 'lps'
  },

  {
    id: "fs",
    name: "Fundscreener",
    img: require("@/assets/products/FS.png"),
    description: "Find and select certain mutual funds or ETFs based on detailed category, performance and risk statistic analysis.",
    landing: "landings_fundscreener",
    video: 'https://player.vimeo.com/video/515166248?title=0&byline=0',
    productCode: 'FS',
    link: "/fundscreener/index",
    defaultLink: "/fundscreener",
    icon:  "FS.png",
    icon2:  "FS.png",
    drawerName: "Fundscreener",
    site: "fundscreener",
    mvp: true,
    rdid: 'fs',
    free: true
  },

  {
    id: "pctnew",
    name: "Portfolio Crash Testing 3.0",
    img: require("@/assets/products/PCT.jpeg"),
    description: "Become a trusted risk management advisor by applying science-based risk software. PCT is a premier portfolio analytics and financial planning tool created by Wall Street quants with decade of experience. Separate yourself from the pack with top notch analytics.",
    landing: "landings_pctpro",
    video: 'https://player.vimeo.com/video/515166248?title=0&byline=0',
    productCode: 'PCT',
    link: "/pctnew/home",
    defaultLink: "/pctnew/home",
    icon:  "pctpro2.png",
    icon2:  "pctpro2.png",
    drawerName: "PCT New",
    site: "pctnew",
    mvp: true,
    rdid: 'pctnew',
  },

  {
    id: "pdf",
    name: "PDF-Parser",
    img: require("@/assets/products/PDF.png"),
    description: "Tool designed for exporting data about funds from Schedule H to excel or a csv file for analysis. PDF Parser converts retirement plan statements into a digestible format which can be uploaded as the company’s retirement plan into the 401kFiduciaryOptimizer and Larkspur Executive.",
    landing: "landings_pdfparser",
    video: 'https://player.vimeo.com/video/468570711?title=0&byline=0&portrait=0',
    productCode: 'PDF',
    link: "/pdfparser/home",
    defaultLink: "/pdfparser",
    icon:  "PDF.png",
    icon2:  "LEXE.png",
    drawerName: "PDF",
    site: "pdfparser",
    mvp: true,
    rd: '/larkspurexecutive/requestdemo?rdemoiframe=true&source=proplus&product=CRM&hide-topmenu=true&appstore=true',
    rdid: 'pdf',
    free: true
  },

  {
    id: "proplus",
    name: "PROPLUS",
    img: require("@/assets/products/PDF.png"),
    description: "Tool designed for exporting data about funds from Schedule H to excel or a csv file for analysis. PDF Parser converts retirement plan statements into a digestible format which can be uploaded as the company’s retirement plan into the 401kFiduciaryOptimizer and Larkspur Executive.",
    landing: "landings_pdfparser",
    video: 'https://player.vimeo.com/video/468570711?title=0&byline=0&portrait=0',
    productCode: 'PDF',
    link: "/requestdemo/LEXE",
    defaultLink: "/pdfparser",
    icon:  "PDF.png",
    icon2:  "LEXE.png",
    drawerName: "PDF",
    site: "proplus",
    mvp: true,
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=PROPLUS',
    rdid: 'proplus',
    free: true,
    hide: true
  },
  {
    id: "pctvideo",
    name: "PCTVIDEO",
    img: require("@/assets/products/PDF.png"),
    description: "pctvideo",
    landing: "landings_pdfparser",
    video: 'https://player.vimeo.com/video/468570711?title=0&byline=0&portrait=0',
    productCode: 'PDF',
    link: "/requestdemo/pctvideo",
    defaultLink: "/pctvideo",
    icon:  "PDF.png",
    icon2:  "LEXE.png",
    drawerName: "PDF",
    site: "pctvideo",
    mvp: true,
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=PCTVIDEO',
    rdid: 'pctvideo',
    hide: true,
    onlyLanding: true
  },
  {
    id: "cmp",
    name: "CAMPAIGNS",
    img: require("@/assets/products/CMP.png"),
    description: "Campaigns - Build up long relationship with clients and follow up leads to close sales with engaging marketing emails",
    video: 'https://player.vimeo.com/video/398820353?dnt=1&app_id=122963',
    landing: 'landings_campaigns',
    productCode: 'CAMPAIGN',
    icon:  "CMP.png",
    icon2:  "CMP.png",
    link: "/campaigns/emailstemplate",
    defaultLink: "/campaigns/emailstemplate",
    drawerName: "Campaigns",
    site: "campaigns",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=CAMPAIGN',
    favicon: 'favicon-lexe.ico',
    rdid: 'cmp',
    mvp: true
  },
  {
    id: "datapage",
    name: "DATAPAGE",
    img: require("@/landings/DATAPAGE/fst_scr.png"),
    description: "Empower Your Sales Team: Close Deals & Keep Great Email Reputation. Most detailed retirement plan & corporate executive contact database",
    video: '/datapage',
    landing: 'data',
    productCode: 'DATAPAGE',
    icon:  "CMP.png",
    icon2:  "CMP.png",
    link: "/",
    defaultLink: "/",
    drawerName: "Datapage",
    site: "datapage",
    rd: '/requestdemo?hide-topmenu=true&appstore=true&product=DATAPAGE',
    favicon: 'favicon-lexe.ico',
    rdid: 'datapage',
    mvp: true,
    onlyLanding: true,
    hideStart: true,
    hideTrial: true,
    hidePlay: true
  }

]


